import React, { Component } from 'react';

class CaptchaInputFields extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            type: '',
            name: '',
            label: '',
            dataerror: '',
            maxLength: '',
            value: '',
            onChange: '',
        }
    }

    changeHandel = (event) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(event);
        }
    }
    onKeyPress = (event) => {
        if (typeof this.props.onKeyPress === 'function') {
            this.props.onKeyPress(event);
        }
    }

    static getDerivedStateFromProps = (nextProps, prevState) => {
        // let prevVal = prevState.value;
        if (prevState.value !== nextProps.value) {
            return { value: nextProps.value };
        }
        return null;
    }

    // componentWillReceiveProps(nextProps) {
    //     this.setState({ 
    //         value: nextProps.value
    //     });
    // }

    chkValBlur = (event) => {
        const { value, id, } = event.target;
        let errorElement = document.getElementById(id).parentNode.querySelector('.error');
        let formField = document.getElementById(id).closest('.form-field');
        if (value == '') {
            if (errorElement) errorElement.classList.remove('hide');
            if (formField) formField.classList.remove('active');
        } else {
            if (errorElement) errorElement.classList.add('hide');
            if (formField) formField.classList.add('active');
        }
    }
    chkValFocus = (event) => {
        const { name, value, id } = event.target;
        let formField = document.getElementById(id).closest('.form-field');
        if (formField) formField.classList.add('active');
    }

    render() {
        let props = this.props;
        return (
            <div className="form-field">
                <div>
                    {props.inputProps.label_before_input == 'true' ?
                        <label htmlFor={props.inputProps.id} className="">{props.inputProps.label}
                            {props.inputProps.validationreq == "true" ? <span className="required" style={{ color: 'red' }}>*</span> : ''}
                        </label>
                        : ''}
                    {props.inputProps.label_before_input == undefined ?
                        <label htmlFor={props.inputProps.id} className="">{props.inputProps.label}</label>
                        : ''}
                    <input {...props.inputProps} onBlur={this.chkValBlur} onFocus={this.chkValFocus} onChange={this.changeHandel} onKeyPress={this.onKeyPress} className={props.inputProps.className ? props.inputProps.className : "form-control"}
                        autoComplete="off" style={{ "width": '230 px' }} />
                    <span className="error show">{props.inputProps.dataerror}</span>
                    {props.inputProps.validation_error ? <span className="error show">{props.inputProps.validation_error}</span> : ''
                    }
                </div>
            </div>
        );
    }
}

export default CaptchaInputFields;
